import React, { ChangeEvent, MutableRefObject, useEffect, useRef, useState } from 'react'
import { CalenderIcon, CloseIcon, DepartmentIcon, DownIcon, FormIconDataPicker, IdIcon, NewWarningIcon, SearchIcon, UpIcon } from '../iconSet/IconSet'
import { AdministrativeLevel, AdministrativeLevels, ASWAdminData, ASWDataRefType, EarlyWarning, EarlyWarningTypeTypes, FlatAdmin, NTWAdminData, NTWDataRefType, ResponseGetActiveWarningDto } from './CreateWarningTypes'
import { convertToOffsetDateTime, flatMap, paginationList, parseCSVManually, sideFieldCount, SubscriberDataType, validateCSVFormat } from './CommonMethods'
import { getAdminLevelByCode, maldivesAdministrativeLevel, sriLankaAdministrationLevel } from './FixedDataSet'
import { AdminData } from './MapSelectorPopup'
import useInputValidate from '../../hooks/useInputValidate'
import { SelectItemTypes } from '../../CommonTypes'
import { InputGroupPropsTypes } from '../inputComp/InputGroupType'
import InputGroup from '../inputComp/InputGroup'
import MapSelector from './MapSelector'
import { APICallGenerateEWMsgRequest, APICallGenerateProcKeyRequest, APICallNewASWRequest, APICallNewWarningRequest, APIRequestAddAreaTypes, APIRequestAddASWAreaTypes, APIRequestAddASWTypes, APIRequestWarningAddTypes, APIWarningTypeResponseType, ResponseTypes } from '../../services/APIEarlyWarningService'
import AlertDialog from '../popupComp/AlertDialog'
import { Department } from '../OrganizationAddUserComp/OrganizationAddUserTypes'
import { useUserData } from '../../context/UserDataContext'
import { APIGetUserAreas } from './CreateWarningService'

import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { useTheme } from '../../context/ThemeContext'
import { APIGetAllCustomSubscribers, Subscriber } from './EarlyWarningService'

type ASWWarningProps = {
    ewType: APIWarningTypeResponseType
    username: string;
}

const ASWWarning = (props: ASWWarningProps) => {

    const { theme } = useTheme()

    const { username, areas } = useUserData()

    const BASE_URL = process.env.REACT_APP_BASE_URL
    const COUNTRY = process.env.REACT_APP_COUNTRY

    const { department, contact } = useUserData()
    
    // New alert level
    const [aswNewAlertLevel, setASWNewAlertLevel] = useState<SelectItemTypes[]>([
        // {name: "Yellow", value: "yellow"},
        // {name: "Amber", value: "amber"},
        // {name: "Red", value: "red"},
        {name: "White", value: "white"},
        {name: "Yellow", value: "yellow"},
        //{name: "Amber", value: "amber"},
        {name: "Orange", value: "amber"},
        {name: "Red", value: "red"},
    ])

    // Lightning alert level
    const [aswPrevAlertLevel, setASWPrevAlertLevel] = useState<SelectItemTypes[]>([
        // {name: "Yellow", value: "yellow"},
        // {name: "Amber", value: "amber"},
        // {name: "Red", value: "red"},
        {name: "White", value: "white"},
        {name: "Yellow", value: "yellow"},
        //{name: "Amber", value: "amber"},
        {name: "Orange", value: "amber"},
        {name: "Red", value: "red"},
    ])

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [hiddenIslandCodes, setHiddenIslandCodes] = useState<string[]>([])

    const [departments, setDepartments] = useState<SelectItemTypes[]>([]);

    const [alertDialogState, setAlertDialogState] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertDescription, setAlertDescription] = useState('');
    const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

    const showAlertDialog = (
    title: string,
    description: string,
    yesCallback?: () => void,
    okCallback?: () => void
    ) => {
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertYesCallback(() => yesCallback); // Will show Yes/Cancel if defined
    setAlertOkCallback(() => okCallback);   // Will trigger only on OK
    setAlertDialogState(true);
    };
  

    // Custom hook
    const {validateField} = useInputValidate()

    // Number of rows in table
    const [numberOfRows, setNumberOfRows] = useState<number>(10)
    const numberOfRowsRef = useRef<HTMLInputElement | null>(null)

    // Supportive document
    const [fileName, setFileName] = useState<string>('Upload');
    const fileInputRef = useRef<HTMLInputElement>(null);

    const aswNumberRef = useRef<HTMLInputElement | null>(null)
    const aswRequestNameRef = useRef<HTMLInputElement | null>(null)
    const aswValidityStartRef = useRef<HTMLInputElement | null>(null)
    const aswValidityEndRef = useRef<HTMLInputElement | null>(null)
    const aswDateRef = useRef<HTMLInputElement | null>(null)
    const aswRequestersDepartmentRef = useRef<HTMLSelectElement | null>(null)

    const aswTextAreaEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    const aswTextAreaDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    const aswTextAreaSinhalaRef = useRef<HTMLTextAreaElement | null>(null)
    const aswTextAreaBengaliRef = useRef<HTMLTextAreaElement | null>(null)
    const aswReportedLinkRef = useRef<HTMLInputElement | null>(null)

    const aswTextAreaCusEnglishRef = useRef<HTMLTextAreaElement | null>(null)
    const aswTextAreaCusDhivehiRef = useRef<HTMLTextAreaElement | null>(null)
    const aswTextAreaCusSinhalaRef = useRef<HTMLTextAreaElement | null>(null)
    const aswTextAreaCusBengaliRef = useRef<HTMLTextAreaElement | null>(null)
    const aswTextAreaCusTamilRef = useRef<HTMLTextAreaElement | null>(null)

    const [messagingAreaStatus, setMessageAreaStatus] = useState<boolean>(false)

    const aswWarningIdRef = useRef<HTMLInputElement | null>(null)

    const [csvErrors, setCSVErrors] = useState<string | null>(null)
    const [fileCSVName, setFileCSVName] = useState<string>('Upload');
    const fileInputCSVRef = useRef<HTMLInputElement>(null)
    const [csvData, setCSVData] = useState<SubscriberDataType[]>([])

    const csvSubNameRef = useRef<HTMLInputElement | null>(null)

    const subscriberSaveRef = useRef<HTMLInputElement | null>(null)

    const [isCSVDataPikerOpen, setIsCSVDataPikerOpen] = useState<boolean>(false)
    const [isCSVDataPickerLoading, setIsCSVDataPickerLoading] = useState<boolean>(false)

    // Selected country
    const country = process.env.REACT_APP_COUNTRY

    // Area selection status
    const [areaSelectType, setAreaSelectType] = useState<'table' | 'map'>('table')

    const [startDate, setStartDate] = useState<string>('')
    const handleStartDateChange = () => {
        if(aswValidityStartRef.current) {
            console.log("data start" ,aswValidityStartRef.current.value)
            setStartDate(aswValidityStartRef.current.value)
        }
    }

    const [endDate, setEndDate] = useState<string>('')
    const handleEndDateChange = () => {
        if(aswValidityEndRef.current) {
            console.log("data end" ,aswValidityEndRef.current)
            setEndDate(aswValidityEndRef.current.value)
        }
    }

    useEffect(() => {
        if (startDate) {
            setASWTableData(prevData =>
                prevData.map(row => {
                    if (row.type === "ASW") {
                        return {
                            ...row,
                            data: {
                                ...row.data,
                                startDate: startDate
                            }
                        };
                    }
                    return row;
                })
            );
        }
    }, [startDate]);

    useEffect(() => {
        if (endDate) {
            setASWTableData(prevData =>
                prevData.map(row => {
                    if (row.type === "ASW") {
                        return {
                            ...row,
                            data: {
                                ...row.data,
                                endDate: endDate
                            }
                        };
                    }
                    return row;
                })
            );
        }
    }, [endDate]);

    const dataMap: InputGroupPropsTypes[] = [
        {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter MWA Number',
            label: 'ASW Number',
            name: 'ASWNumber',
            required: true,
            componentInputElement: aswNumberRef,
            disabled: true
        },
        {
            type: 'text',
            icon: <IdIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter Request Name',
            label: 'Request Name',
            name: 'RequestName',
            required: false,
            componentInputElement: aswRequestNameRef,
            disabled: true
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter start valid period',
            label: 'validity start time',
            name: 'validityStartTime',
            required: true,
            componentInputElement: aswValidityStartRef,
            onChange: handleStartDateChange
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter end valid period',
            label: 'validity end time',
            name: 'validityEndTime',
            required: true,
            componentInputElement: aswValidityEndRef,
            onChange: handleEndDateChange
        },
        {
            type: 'date-time',
            icon: <CalenderIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            placeholder: 'Enter end valid period',
            label: 'ASW Date',
            name: 'ASWDate',
            required: true,
            componentInputElement: aswDateRef,
        },
        {
            type: 'select',
            icon: <DepartmentIcon width="1.5rem" color="var(--color-main-white)" />,
            color: 'var(--color-accent-bg)',
            label: 'requester\'s department',
            name: 'requestersDepartment',
            required: false,
            placeholder: 'Not selected',
            componentSelectElement: aswRequestersDepartmentRef,
            optionList: departments,
            disabled: true
        }
    ]

    // Table data row
    //const [tableData, setTableData] = useState<AdministrativeLevels>(sriLankaAdministrationLevel)
    const [selectedCodes, setSelectedCodes] = useState(new Set());
    const [filterTableData, setFilterTableData] = useState<FlatAdmin[]>([])
    const [tableData, setTableData] = useState<FlatAdmin[]>([])
    const [pagination, setPagination] = useState<FlatAdmin[][]>([])
    const [selectedPagination, setSelectedPagination] = useState<number>(0)

    const [ASWTableData, setASWTableData] = useState<AdminData[]>([])
    const ASWTableDataRef = useRef<AdminData[]>([])
    const ASWObjectRef = useRef<ASWDataRefType>({
        warningNumber: '',
        requestName: '',
        requestsDepartment: '',
        validityStartTime: '',
        validityEndTime: '',
        adminData: [],
        desEnglish: '',
        desDhivehi: '',
        desSinhala: '',
        desBengali: '',
        reportedLink: '',
        supportDocument: null,
        warningId: '',
        
        desCusEnglish: '',
        desCusDhivehi: '',
        desCusSinhala: '',
        desCusBengali: '',
        desCusTamil: '',
    })

    const [oldAlert, setOldAlert] = useState<ResponseGetActiveWarningDto[]>([])
 
    useEffect(() => {
        setASWTableData(prevState => {
            const updatedState = [...prevState]
            
            oldAlert.forEach(alertItem => {
                const index = updatedState.findIndex(item => item.type === "ASW" && item.data.code === alertItem.areaCode)

                if (index !== -1) {
                    // Item exists → update only previousAlertLevel
                    const currentItem = updatedState[index];
                    if (currentItem.type === "ASW") {
                        updatedState[index] = {
                            ...currentItem,
                            data: {
                                ...currentItem.data,
                                previousAlertLevel: alertItem.status || ""
                            }
                        };
                    }
                } else {
                    // Item does not exist → add new LSW item
                    const newASW: ASWAdminData = {
                        code: alertItem.areaCode,
                        name: "",
                        adminName: "",
                        adminLevel: getAdminLevelByCode(alertItem.areaCode),
                        isSelected: true,
                        previousAlertLevel: alertItem.status || "",
                        newAlertLevel: "",
                        startDate: startDate || "",
                        endDate: endDate || ""
                    }
                    updatedState.push({ type: "ASW", data: newASW } as AdminData);
                }
            })
            return updatedState;
        })
        
    }, [oldAlert])

    const [selectedArea, setSelectedArea] = useState<string[]>([])
    const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
        
        if (event.target.checked) {
            setSelectedArea(prevState => [...prevState, event.target.name])
        } else {
            setSelectedArea(prevState => prevState.filter(item => item !== event.target.name))
        }
    }

    // Pagination next prev navigation
    const paginationNavigation = ( side: "next" | "prev") => {
        if (side === "next") {
            if (pagination.length > selectedPagination + 1) {
                setSelectedPagination(prevState => prevState + 1)
            }
           
        } else if (side === "prev") {
            if (0 <= selectedPagination - 1){
                setSelectedPagination(prevState => prevState - 1)
            }
        }
    }

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setFileName(event.target.files[0].name);
            ASWObjectRef.current.supportDocument = event.target.files[0]
        } else {
            setFileName('Upload');
        }
    }

    const handleGenerateEWMessageData = async (event: React.MouseEvent<HTMLButtonElement>) => {
        setIsLoading(true)

        const aswValidityStartRefField = validateField(aswValidityStartRef)
        const aswValidityEndRefField = validateField(aswValidityEndRef)

        if (!aswValidityStartRefField || !aswValidityEndRefField) {
            setIsLoading(false)
            return showAlertDialog("Validation Error", "❌ Validation error");
        } 

        for (const item of ASWTableData) {
            const data = item.data as ASWAdminData;

            // Check if data.code exists in oldAlert
            const existsInOldAlert = oldAlert.some(alert => alert.areaCode === data.code);
            //console.log("VALIDATE ", existsInOldAlert)
            if (!data.newAlertLevel && !existsInOldAlert) {
                showAlertDialog(
                    "Validation Error",
                    "New alert level must be selected in all selected locations"
                );
                setIsLoading(false);
                return
        }}

        if(aswValidityStartRef.current && aswValidityEndRef.current && ASWTableDataRef.current && aswTextAreaEnglishRef.current && aswTextAreaDhivehiRef.current && aswReportedLinkRef.current && fileInputRef.current && aswNumberRef.current && aswRequestNameRef.current && aswRequestersDepartmentRef.current && csvSubNameRef.current && subscriberSaveRef.current) 
        {
            ASWObjectRef.current.warningNumber = aswNumberRef.current.value
            ASWObjectRef.current.requestName = aswRequestNameRef.current.value
            ASWObjectRef.current.requestsDepartment = aswRequestersDepartmentRef.current.value
            ASWObjectRef.current.validityStartTime = aswValidityStartRef.current.value
            ASWObjectRef.current.validityEndTime = aswValidityEndRef.current.value
            
            ASWTableData.map(item => {
                ASWObjectRef.current.adminData.push(item.data as ASWAdminData)
            })
            //ASWObjectRef.current.adminData = ASWTableDataRef.current
            ASWObjectRef.current.desEnglish = aswTextAreaEnglishRef.current.value
            ASWObjectRef.current.desDhivehi = aswTextAreaDhivehiRef.current.value
            

            if (COUNTRY === "SRI_LANKA" && aswTextAreaSinhalaRef.current)
            {
                ASWObjectRef.current.desSinhala = aswTextAreaSinhalaRef.current.value
            }

            if (COUNTRY === "MALDIVES" && aswTextAreaBengaliRef.current)
            {
                ASWObjectRef.current.desBengali = aswTextAreaBengaliRef.current.value
            }

            
            ASWObjectRef.current.reportedLink = aswReportedLinkRef.current.value
            ASWObjectRef.current.warningId = props.ewType.warningId

            const aswData: ASWDataRefType = ASWObjectRef.current
                                                        
            const aswAdminData: APIRequestAddAreaTypes[] = []
            
            aswData.adminData.map(area => {
                const newAdmin: APIRequestAddAreaTypes = {
                    code: area.code,
                    administrationName: area.adminName,
                    administrationLevel: area.adminLevel,
                    previousAlertLevel: area.previousAlertLevel,
                    newAlertLevel: area.newAlertLevel,
                    startDate: convertToOffsetDateTime(area.startDate),
                    endDate: convertToOffsetDateTime(area.endDate)
                }
                aswAdminData.push(newAdmin)
            })
    
            const ASWNewRequestBody: APIRequestWarningAddTypes = {
                type: 'ASW',
                warningNumber: aswData.warningNumber,
                requestName: aswData.requestName,
                requestersDepartment: aswData.requestsDepartment,
                validityStartTime: convertToOffsetDateTime(aswData.validityStartTime),
                validityEndTime: convertToOffsetDateTime(aswData.validityEndTime),
                effectedAreas: aswAdminData,
                messageBodyEnglish: aswData.desEnglish,
                messageBodyDhivehi: aswData.desDhivehi,
                messageBodySinhala: aswData.desSinhala,
                messageBodyBengali: aswData.desBengali,
                reportLink: aswData.reportedLink,
                supportiveDocument: aswData.supportDocument,
                warningId: aswData.warningId,
                triggerType: '',
                csvData: csvData,
                isCsvSave: subscriberSaveRef.current.checked,
                csvName: csvSubNameRef.current.value === '' || csvSubNameRef.current.value === null ? fileCSVName.split('.')[0] : csvSubNameRef.current.value
            }
                    try {
                        const response = await APICallGenerateEWMsgRequest(ASWNewRequestBody)

                        if (!response.errorCode) {
                            //console.log(response);


                            if (aswTextAreaEnglishRef.current && aswTextAreaDhivehiRef.current) {

                                // After got response set to field
                                aswTextAreaEnglishRef.current.value = response.data.ew_generalMsgLanBase // English data in response
                                aswTextAreaDhivehiRef.current.value =response.data.ew_generalMsgLanDV // Dhivehi data in response

                                if (COUNTRY === "SRI_LANKA" && aswTextAreaSinhalaRef.current)
                                {
                                    aswTextAreaSinhalaRef.current.value = response.data.ew_generalMsgLanSI // Sinhala data in response
                                }
                    
                                if (COUNTRY === "MALDIVES" && aswTextAreaBengaliRef.current)
                                {
                                    aswTextAreaBengaliRef.current.value = response.data.ew_generalMsgLanBN // Bengali data in response
                                }
                            }
                            
                        }
                        else {
                            switch (response.errorCode) {
                                case 1010:
                                    console.log("❌ ", response.errorMessage);
                                    showAlertDialog("Unauthorized", "❌ Unauthorized request");
                                    break
                                default:
                                    console.log("❌ ", response.errorMessage);
                                    showAlertDialog("Error", "❌ Error adding data");
                            }

                        }
                    }
                    catch (ex) {
                        console.error("❌ HRW submit exception:", ex);
                        showAlertDialog("Submit Error", "❌ HRW submit exception");
                    }
                } else {
                    showAlertDialog("Validation Error", "Validation error");
                }
                setIsLoading(false)
            }

    // Handle save data
    const handleSaveClick = async (event: React.MouseEvent<HTMLButtonElement>) => {

        setIsLoading(true)

        const aswValidityStartRefField = validateField(aswValidityStartRef)
        const aswValidityEndRefField = validateField(aswValidityEndRef)

        if (!aswValidityStartRefField || !aswValidityEndRefField) {
            setIsLoading(false)
            return showAlertDialog("Validation Error", "❌ Validation error");
        } 

        for (const item of ASWTableData) {
            const data = item.data as ASWAdminData;

            // Check if data.code exists in oldAlert
            const existsInOldAlert = oldAlert.some(alert => alert.areaCode === data.code);
            //console.log("VALIDATE ", existsInOldAlert)
            if (!data.newAlertLevel && !existsInOldAlert) {
                showAlertDialog(
                    "Validation Error",
                    "New alert level must be selected in all selected locations"
                );
                setIsLoading(false);
                return
        }}

            if(aswValidityStartRef.current && aswValidityEndRef.current && ASWTableDataRef.current && aswTextAreaEnglishRef.current && aswTextAreaDhivehiRef.current && aswReportedLinkRef.current && fileInputRef.current && aswNumberRef.current && aswRequestNameRef.current && aswRequestersDepartmentRef.current && csvSubNameRef.current && subscriberSaveRef.current && aswTextAreaCusDhivehiRef.current && aswTextAreaCusEnglishRef.current) 
            {
                ASWObjectRef.current.warningNumber = aswNumberRef.current.value
                ASWObjectRef.current.requestName = aswRequestNameRef.current.value
                ASWObjectRef.current.requestsDepartment = aswRequestersDepartmentRef.current.value
                ASWObjectRef.current.validityStartTime = aswValidityStartRef.current.value
                ASWObjectRef.current.validityEndTime = aswValidityEndRef.current.value
                
                ASWTableData.map(item => {
                    ASWObjectRef.current.adminData.push(item.data as ASWAdminData)
                })
                //ASWObjectRef.current.adminData = ASWTableDataRef.current
                ASWObjectRef.current.desEnglish = aswTextAreaEnglishRef.current.value
                ASWObjectRef.current.desCusEnglish = aswTextAreaCusEnglishRef.current.value

                ASWObjectRef.current.desDhivehi = aswTextAreaDhivehiRef.current.value
                ASWObjectRef.current.desCusDhivehi = aswTextAreaCusDhivehiRef.current.value

                if (COUNTRY === "SRI_LANKA" && aswTextAreaSinhalaRef.current)
                {
                    ASWObjectRef.current.desSinhala = aswTextAreaSinhalaRef.current.value
                }
    
                if (COUNTRY === "MALDIVES" && aswTextAreaBengaliRef.current && aswTextAreaCusBengaliRef.current)
                {
                    ASWObjectRef.current.desBengali = aswTextAreaBengaliRef.current.value
                    ASWObjectRef.current.desCusBengali = aswTextAreaCusBengaliRef.current.value
                }

                ASWObjectRef.current.reportedLink = aswReportedLinkRef.current.value
                ASWObjectRef.current.warningId = props.ewType.warningId


                const aswData: ASWDataRefType = ASWObjectRef.current
                                                                                        
                const aswAdminData: APIRequestAddAreaTypes[] = []
        
                aswData.adminData.map(area => {
                    const newAdmin: APIRequestAddAreaTypes = {
                        code: area.code,
                        administrationName: area.adminName,
                        administrationLevel: area.adminLevel,
                        previousAlertLevel: area.previousAlertLevel,
                        newAlertLevel: area.newAlertLevel,
                        startDate: convertToOffsetDateTime(area.startDate),
                        endDate: convertToOffsetDateTime(area.endDate)
                    }
                    aswAdminData.push(newAdmin)
                })
        
                const ASWNewRequestBody: APIRequestWarningAddTypes = {
                    type: 'ASW',
                    warningNumber: aswData.warningNumber,
                    requestName: aswData.requestName,
                    requestersDepartment: aswData.requestsDepartment,
                    validityStartTime: convertToOffsetDateTime(aswData.validityStartTime),
                    validityEndTime: convertToOffsetDateTime(aswData.validityEndTime),
                    effectedAreas: aswAdminData,
                    messageBodyEnglish: aswData.desEnglish,
                    messageBodyDhivehi: aswData.desDhivehi,
                    messageBodySinhala: aswData.desSinhala,
                    messageBodyBengali: aswData.desBengali,
                    reportLink: aswData.reportedLink,
                    supportiveDocument: aswData.supportDocument,
                    warningId: aswData.warningId,
                    triggerType: '',
                    csvData: csvData,
                    isCsvSave: subscriberSaveRef.current.checked,
                    csvName: csvSubNameRef.current.value === '' || csvSubNameRef.current.value === null ? fileCSVName.split('.')[0] : csvSubNameRef.current.value,

                    messageCusBodyEnglish: aswData.desCusEnglish,
                    messageCusBodyDhivehi: aswData.desCusDhivehi,
                    messageCusBodySinhala: aswData.desCusSinhala,
                    messageCusBodyBengali: aswData.desCusBengali,
                    messageCusBodyTamil: aswData.desCusTamil,
                }
        
                // Send request
                try
                {
                    const response: ResponseTypes = await APICallNewWarningRequest(ASWNewRequestBody)
                    
                    if (!response.errorCode)
                    {
                        console.log("✅ ASW submitted successfully")
                        showAlertDialog("Success", "✅ ASW submitted successfully!", undefined, () => window.location.reload());
                    } 
                    else 
                    {
                        switch (response.errorCode) {
                            case 1010:
                                console.log("❌ ", response.errorMessage)
                                showAlertDialog("Unauthorized", "❌ Unauthorized request");
                                break
                            default:
                                console.log("❌ ", response.errorMessage)
                                showAlertDialog("Error", "❌ Error adding data");
                        }
                        
                    }
                } 
                catch (ex)
                {
                    console.error("❌ ASW submit exception:", ex);
                    showAlertDialog("Submit Error", "❌ ASW submit exception");
                }
            }
            else {
                showAlertDialog("Validation Error", "❌ Validation error");
            }
            setIsLoading(false)
    }

    const [allowedAreas, setAllowedAreas] = useState<string[]>([])
    useEffect(() => {
        // const getUserAreas = async () => {
        //     const response = await APIGetUserAreas()
        //     //console.log('AREAS ->', response.data)
        //     if (!response)
        //     {
        //         showAlertDialog('Error', '❌ data loading failed')
        //     }
            
        //     setAllowedAreas(response.data)

        //     if (country === "SRI_LANKA") {
        //         const flat = flatMap(sriLankaAdministrationLevel, selectedArea)
        //         setTableData(flat)
        //         setFilterTableData(flat)
        //     } else if (country === "MALDIVES") {
        //         const flat = flatMap(maldivesAdministrativeLevel, selectedArea)
        //         const filtered: FlatAdmin[] = flat.filter(item => response.data.some(code => item.code.startsWith(code)))
        //         setTableData(filtered)
        //         setFilterTableData(filtered)
        //     }
        // }
        // getUserAreas()

        setAllowedAreas(areas)
        
        if (country === "SRI_LANKA") {
            const flat = flatMap(sriLankaAdministrationLevel, selectedArea)
            setTableData(flat)
            setFilterTableData(flat)
        } else if (country === "MALDIVES") {
            const flat = flatMap(maldivesAdministrativeLevel, selectedArea)
            const filtered: FlatAdmin[] = flat.filter(item => areas.some(code => item.code.startsWith(code)))
            setTableData(filtered)
            setFilterTableData(filtered)
        }
    }, [])

    useEffect(() => {
        setPagination(paginationList(filterTableData, numberOfRows))
    }, [tableData, filterTableData, numberOfRows])

    // Handle table search
    const handelSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "") {
            setFilterTableData(tableData)
        } else {
            setFilterTableData(tableData.filter(item => item.name.toLowerCase().includes(event.target.value.toLowerCase())))
        }
    }

    const handleASWPrevAlert = (event: ChangeEvent<HTMLSelectElement>) => {
        const code = event.target.name;
        const value = event.target.value;

        setASWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "ASW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            previousAlert: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleASWNewAlert = (event: ChangeEvent<HTMLSelectElement>) => {
        const code = event.target.name;
        const value = event.target.value
        
        setASWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "ASW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            newAlertLevel: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleASWStartDate = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name
        const value = event.target.value
        
        setASWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "ASW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            startData: value
                        }
                    };
                }
                return row;
            })
        )
    }

    const handleASWEndDate = (event: ChangeEvent<HTMLInputElement>) => {
        const code = event.target.name
        const value = event.target.value
        
        setASWTableData(prevData =>
            prevData.map(row => {
                if (row.type === "ASW" && row.data.code === code) {
                    return {
                        ...row,
                        data: {
                            ...row.data,
                            endDate: value
                        }
                    };
                }
                return row;
            })
        )
    }
    
    const getAllChildIslandCodes = (level: AdministrativeLevel): string[] => {
            if (!level.children) return [];
    
            const codes: string[] = [];
            Object.entries(level.children).forEach(([code, child]) => {
                if (child.adminLevel === 'island') {
                    codes.push(code);
                }
    
                // Recurse deeper
                codes.push(...getAllChildIslandCodes(child));
            });
    
            return codes;
        }
    
    const findAdminByCode = (levels: AdministrativeLevels, code: string): AdministrativeLevel | null => {
        for (const [key, level] of Object.entries(levels)) {
            if (key === code) return level;
            if (level.children) {
            const result = findAdminByCode(level.children, code);
            if (result) return result;
            }
        }
        return null;
    }

    useEffect(() => {
        const visibleData = filterTableData.filter(item => !hiddenIslandCodes.includes(item.code));
        const paginated = paginationList(visibleData, numberOfRows);
        setPagination(paginated);

        // Reset to first page if current page is out of bounds after filtering
        if (selectedPagination >= paginated.length) {
            setSelectedPagination(0);
        }
    }, [filterTableData, numberOfRows, hiddenIslandCodes])

    // Handle check box click
    const handleCheckBoxClick = (event: ChangeEvent<HTMLInputElement>) => {
        handleCheckBox(event);

        const code = event.target.name;
        const isChecked = event.target.checked;

        const adminSource = country === 'SRI_LANKA' ? sriLankaAdministrationLevel : maldivesAdministrativeLevel;
        const clickedAdminLevel = findAdminByCode(adminSource, code);

        if (clickedAdminLevel && clickedAdminLevel.adminLevel === 'atoll') 
        {
            //const childIslandCodes = getAllChildIslandCodes(clickedAdminLevel)
            //setHiddenIslandCodes(prev => isChecked ? [...prev, ...childIslandCodes] : prev.filter(code => !childIslandCodes.includes(code)))
            const childIslandCodes = getAllChildIslandCodes(clickedAdminLevel);
            setHiddenIslandCodes(prev =>
                isChecked
                ? [...prev, ...childIslandCodes] // hide children
                : prev.filter(code => !childIslandCodes.includes(code)) // show again
            );
        }

        if (event.target.checked) 
        {
            const alreadyExists = ASWTableData.some(item => item.type === 'ASW' && item.data.code === event.target.name)
            
            if (!alreadyExists) 
            {
                console.log("Already exists")
                const data = tableData.find(obj => obj.code === event.target.name);
                if (data) {
                    
                    setASWTableData(prevState => {
                        return [...prevState, {
                            type: 'ASW',
                            data: {
                                isSelected: true,
                                name: data.name,
                                code: data.code,
                                adminName: data.adminLevel,
                                adminLevel: data.adminLevel,
                                newAlertLevel: "",
                                previousAlertLevel: "",
                                startDate: aswValidityStartRef.current?.value || '',
                                endDate: aswValidityEndRef.current?.value || ''
                            }
                        }]
                    })
                }
            }
        } 
        else 
        {
            setASWTableData(prevState => prevState.filter(item => !(item.type === 'ASW' && item.data.code === event.target.name)))
        }
    }

    // Handle Row number change
    const handleRowNumberChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setNumberOfRows(event.target.valueAsNumber)
    }

    useEffect(() => {
        // let department = ''
        // let contact = ""
        // const userJson = sessionStorage.getItem("userdetails")
        // if (userJson) 
        // {
        //     const user = JSON.parse(userJson);
        //     department = user.department
        //     contact = user.mobilenumber
        // }
        const token = localStorage.getItem("access_token");
        fetch(BASE_URL + "/identity_manager/api/v1/getalldepartments", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            })
            .then((res) => res.json())
            .then((data) => {
                //console.log("Fetched organizations in Create Org:", data)
                const departmentData: SelectItemTypes[] = []
                data.map((item: Department) => {
                    departmentData.push({value: item.departmentid, name: item.departmentname})
                })
                setDepartments(departmentData)
            })
            .catch((err) => console.error("Error fetching organizations:", err))

        if (aswRequestNameRef.current && aswDateRef.current && aswRequestersDepartmentRef.current) 
        {
            aswRequestNameRef.current.value = props.ewType.warningId
            aswRequestersDepartmentRef.current.value = department
            
            const now = new Date();

            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')

            // Format: "2025-07-21T14:30"
            const currentDateTime = `${year}-${month}-${day}T${hours}:${minutes}`
            aswDateRef.current.value = currentDateTime
        }

        fetch(`${BASE_URL}/ew/api/v1/getCurrentProcess?type=FLW`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
        .then(response => response.json())
        .then(data => {
            const values = data as ResponseTypes
            const newData = values.data as ResponseGetActiveWarningDto[]
            setOldAlert(newData)
        })
    }, [])

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response = await APICallGenerateProcKeyRequest(props.ewType.warningId); // Pass prop here
                if (response && !response.errorCode) {
                    //console.log("✅ API data loaded: ", response);
                    // Example: store a process key in state
                    // setProcKey(response.processKey);

                    if (aswNumberRef.current) {
                        aswNumberRef.current.value = response.data;
                    }

                } else {
                    console.warn("⚠️ API returned an error:", response?.errorMessage);
                    showAlertDialog("Error", "Failed to load initial data");
                }
            } catch (error) {
                console.error("❌ Error fetching data:", error);
                showAlertDialog("Network Error", "Failed to fetch initial data.");
            }
        };

        fetchInitialData();
    }, [props.ewType]);

    useEffect(() => {
        if (aswRequestNameRef.current/*  && aswDateRef.current */)
        {
            aswRequestNameRef.current.value = props.ewType.warningId

            const now = new Date();

            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')

            // Format: "2025-07-21T14:30"
            const currentDateTime = `${year}-${month}-${day}T${hours}:${minutes}`
        }
    }, [])

    const handleCSVFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        setCSVErrors(null)
        if (event.target.files && event.target.files.length > 0) {
            setFileCSVName(event.target.files[0].name)
            const file = event.target.files[0]
            
            // Validate File Extension
            if (!file.name.endsWith('.csv'))
            {
                setCSVErrors("Invalid file type. Please upload a CSV file.")
                event.target.value = ''
                return
            }
            else
            {
                setFileCSVName(file.name)
                
                const reader = new FileReader()

                reader.onload = (e) => {

                    const text = e.target?.result as string

                    if (!validateCSVFormat(text).valid)
                    {
                        setCSVErrors("Invalid CSV format. Please upload a CSV file with the correct format.")
                        event.target.value = ''
                        return
                    }

                    const parsedData = parseCSVManually(text)
                    setCSVData(parsedData)
                }

                reader.onerror = () => {
                    setCSVErrors("Error reading CSV file. Please try again.")
                }
                
                reader.readAsText(file)
            }
        } else {
            setFileCSVName('Upload');
        }
    }

    const clearCSV = () => {
        if (!fileInputCSVRef.current) return

        fileInputCSVRef.current.value = ''
        setFileCSVName('Upload')
        setCSVData([])
        setCSVErrors(null)
    }

    const handleClickSaveAndSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (csvErrors !== null)
        {
            showAlertDialog("CSV Error", "Loaded CSV file detected error. Please fix CSV error before submit. if submit without fix CSV error, CSV data will not be uploaded. Do you need to proceed?", () => handleSaveClick(event), undefined)
        }
        else
        {
            showAlertDialog("Confirm Submit", "Are you sure you want to submit this early warning?", () => handleSaveClick(event), undefined)
        }
    }

    const handleClearCSV = () => {
        setCSVErrors(null)
        setFileCSVName('Upload')
        setCSVData([])
    }

    const existingCSVDataRef = useRef<string[]>([])
    const existingCSVDataSetRef = useRef<SubscriberDataType[]>([])
    const [existingCSVFilterData, setExistingCSVFilterData] = useState<string[]>([])

    // existing data change handle
    const handleChangeExistingDataSearch = (event: ChangeEvent<HTMLInputElement>): void => {
        if (event.target.value === "") 
        {
            setExistingCSVFilterData(existingCSVDataRef.current);
        } 
        else 
        {
            setExistingCSVFilterData(
                existingCSVDataRef.current.filter((item) =>
                    item.toLowerCase().includes(event.target.value.toLowerCase())
                )
            );
        }
    }

    useEffect(() => {
        const fetchExistingCSVData = async () => {
            setIsCSVDataPickerLoading(true)
            const response = await APIGetAllCustomSubscribers(props.ewType.warningId)

            if (!response.status)
            {

            }
            const tempData: SubscriberDataType[] = []
            const tempFileNames: string[] = []

            response.data?.map(item => {
                tempFileNames.push(item.name)
                item.subscribers.map((subscriber: Subscriber) => {
                    const sub: SubscriberDataType = {
                        name: item.name,
                        whatsappContact: subscriber.whatsappContact,
                        whatsapp: subscriber.whatsapp,
                        smsContact: subscriber.smsContact,
                        sms: subscriber.sms,
                        viberContact: subscriber.viberContact,
                        viber: subscriber.viber,
                        email: subscriber.email
                    }
                    tempData.push(sub)
                })
            })
            existingCSVDataSetRef.current = tempData
            existingCSVDataRef.current = tempFileNames
            setExistingCSVFilterData(tempFileNames)
        }

        fetchExistingCSVData()
        setIsCSVDataPickerLoading(false)
    }, [])

    const handleClickFilteredCSV = (sub: string): void => {
        setCSVData(existingCSVDataSetRef.current.filter(item => item.name === sub))
        setCSVErrors(null)
        csvSubNameRef.current!.value = sub
        setFileCSVName(sub)
        setIsCSVDataPikerOpen(false)
    }

    return (
        <div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details ({props.ewType.warningName})</span>
                </div>
                <div className='details-selector-wrapper-container' style={{backgroundColor: 'transparent'}}>
                    <div className={`left-side`}>
                        {dataMap.slice(0, sideFieldCount(dataMap.length)).map((field, index) => (
                            <InputGroup key={index} {...field}/>
                        ))}
                    </div>

                    <div className={`right-side`}>
                        {dataMap.slice(sideFieldCount(dataMap.length)).map((field, index) => (
                            <InputGroup key={index} {...field}/>
                        ))}
                    </div>
                </div>
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Area Selection)</span>
                </div>
                <div className='tab-button-wrapper'>
                    <span style={{backgroundColor: areaSelectType === 'table' ? 'var(--color-warning-table-bg)' : 'var(--color-container-form-bg)'}} onClick={() => setAreaSelectType('table')}>table view mode</span>
                    <span style={{backgroundColor: areaSelectType === 'map' ? 'var(--color-warning-table-bg)' : 'var(--color-container-form-bg)'}} onClick={() => setAreaSelectType('map')}>map view mode</span>
                </div>
                {areaSelectType === 'table' && (
                    <div className='details-selector-wrapper-table-container' style={{backgroundColor: 'transparent'}}>
                        <div className='area-table-wrapper'>
                            <div className='field-container'>
                                <div className='input-group' style={{width: '20rem'}}>
                                    <label htmlFor="">display row count</label>
                                    <input ref={numberOfRowsRef} defaultValue={10} min={10} max={30} type="number" onChange={(e) => handleRowNumberChanged(e)} />
                                </div>
                                <div className='input-group'>
                                    <i><SearchIcon width="1rem" color="var(--color-main-white)" /></i>
                                    <input type="text" name="" id="" placeholder='Search location' onChange={(e) => handelSearchChange(e)}/>
                                </div>
                            </div>
                            <div className='table-wrapper'>
                                <div className='row header'>
                                    <div className='cell' style={{flex: 0.2, minWidth: '3rem'}}>
                                        <span></span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Administration Name</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Administration Level</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Previous Alert Level</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>New Alert Level</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>Start Date</span>
                                    </div>
                                    <div className='cell' style={{minWidth: '8.3rem'}}>
                                        <span>End Date</span>
                                    </div>
                                </div>

                                {pagination[selectedPagination]?.map((item, index) => {
                                    const currentRowState = ASWTableData.find((row): row is { type: 'ASW'; data: ASWAdminData } => row.type === 'ASW' && row.data.code === item.code )?.data ?? {
                                            isSelected: false,
                                            code: item.code,
                                            name: item.name,
                                            adminName: item.name,
                                            adminLevel: item.adminLevel,
                                            previousAlertLevel: "",
                                            newAlertLevel: "",
                                            startDate: startDate,
                                            endDate: endDate,
                                        };

                                    return (
                                        <div key={index} className='row'>
                                            <div className='cell' style={{flex: 0.2, minWidth: '3rem'}}>
                                                <input type="checkbox" name={item.code} checked={currentRowState.isSelected} onChange={handleCheckBoxClick} />
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <span>{item.name}</span>
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <span>{item.adminLevel}</span>
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <select name={item.code} value={currentRowState.previousAlertLevel || ''} onChange={(e) => handleASWPrevAlert(e)} >
                                                    <option value="">No alert</option>
                                                    {aswPrevAlertLevel.map((opt, idx) => (
                                                        <option key={idx} value={opt.value}>{opt.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem'}}>
                                                <select name={item.code} value={currentRowState.newAlertLevel || ''} onChange={(e) => handleASWNewAlert(e)}>
                                                    <option value="">No alert</option>
                                                    {aswNewAlertLevel.map((opt, idx) => (
                                                        <option key={idx} value={opt.value}>{opt.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            
                                            <div className='cell' style={{minWidth: '8rem', justifyContent: 'center'}}>
                                                <input type="datetime-local" defaultValue={currentRowState.startDate || startDate} name={item.code} onChange={(e) => handleASWStartDate(e)} style={{width: '8rem'}} />
                                            </div>
                                            <div className='cell' style={{minWidth: '8rem', justifyContent: 'center'}}>
                                                <input type="datetime-local" defaultValue={currentRowState.endDate || endDate} name={item.code} onChange={(e) => handleASWEndDate(e)} style={{width: '8rem'}} />
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                        </div>
                        <div className='pagination-wrapper'>
                            <div className='icon-page-box' style={{marginBottom: "0.7rem"}} onClick={(e) => paginationNavigation("prev")}>&lt;</div>
                            <div className='page-wrapper'>
                                {pagination.map((page, index) => (
                                    <div key={index} className={selectedPagination === index ? 'icon-page-box selected' : 'icon-page-box'} onClick={(e) => setSelectedPagination(index)}>{index + 1}</div>
                                ))}
                            </div>
                            <div className='icon-page-box' style={{marginBottom: "0.7rem"}} onClick={(e) => paginationNavigation("next")}>&gt;</div>
                        </div>
                    </div>
                )}
                {areaSelectType === 'map' && (
                    <div className='map-wrapper'>
                        <MapSelector type='ASW' setData={ASWTableDataRef} startDate={startDate} endDate={endDate} tableData={ASWTableData} setTableData={setASWTableData} allowedAreas={allowedAreas}/>
                    </div>
                )}
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Intended Dissemination of Information to People)</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container'>
                        <span>message body SMS - english</span>
                        <textarea ref={aswTextAreaEnglishRef} name="" id=""></textarea>
                    </div>
                    <div className='form-container'>
                        <span>message body SMS - dhivehi</span>
                        <textarea ref={aswTextAreaDhivehiRef} name="" id=""></textarea>
                    </div>

                    {COUNTRY === "SRI_LANKA" ? (
                        <div className='form-container'>
                            <span>message body SMS - sinhala</span>
                            <textarea ref={aswTextAreaSinhalaRef} name="" id=""></textarea>
                        </div>
                    ) : COUNTRY === "MALDIVES" ? (
                        <div className='form-container'>
                            <span>message body SMS - Bengali</span>
                            <textarea ref={aswTextAreaBengaliRef} name="" id=""></textarea>
                        </div>
                    ) : null}
                    
                    <div className='form-container' style={{alignItems: 'center'}}>
                        <span>report link</span>
                        <input ref={aswReportedLinkRef} type='text' name="" id=""></input>
                    </div>
                    <div className='button-wrapper'>
                        <button onClick={(e) => handleGenerateEWMessageData(e)}>generate EW message data</button>
                    </div>

                    {/* More message options */}
                    <div className='message-more-wrapper'>
                        <div className='title-wrapper'>
                            <span className='title' onClick={() => setMessageAreaStatus(prevState => !prevState)}>More Messaging options..</span>
                            <div>
                                {messagingAreaStatus ? <UpIcon width='0.8rem' color='var(--color-text)' /> : <DownIcon width='1rem' color='var(--color-text)' />}
                            </div>
                        </div>
                        <div className='data-wrapper' style={{ maxHeight: messagingAreaStatus ? '500px' : '0' }}>
                            
                            <div className='messaging-legend-wrapper'>
                                <span>Message Placeholders</span>
                                <div>
                                    <span>Warning Id: {'${warningId}'}</span>
                                    <span>Warning Name: {'${warningName}'}</span>
                                    <span>Area Name: {'${areaName}'}</span>
                                    <span>Severity: {'${severity}'}</span>
                                    <span>Validity Start Time: {'${validityStart}'}</span>
                                    <span>Validity End Time: {'${validityEnd}'}</span>
                                </div>
                            </div>

                            <div className='form-container'>
                                <span>local message body - english</span>
                                <textarea ref={aswTextAreaCusEnglishRef} name="" id=""></textarea>
                            </div>
                            
                            {COUNTRY === "SRI_LANKA" ? (
                                <>
                                    <div className='form-container'>
                                        <span>local message body - sinhala</span>
                                        <textarea ref={aswTextAreaCusSinhalaRef} name="" id=""></textarea>
                                    </div>

                                    <div className='form-container'>
                                        <span>local message body - tamil</span>
                                        <textarea ref={aswTextAreaCusTamilRef} name="" id=""></textarea>
                                    </div>
                                </>
                                
                            ) : COUNTRY === "MALDIVES" ? (
                                <>
                                    <div className='form-container'>
                                        <span>local message body - dhivehi</span>
                                        <textarea ref={aswTextAreaCusDhivehiRef} name="" id=""></textarea>
                                    </div>

                                    <div className='form-container'>
                                        <span>local message body - Bengali</span>
                                        <textarea ref={aswTextAreaCusBengaliRef} name="" id=""></textarea>
                                    </div>
                                </>
                                
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Early Warning Details (Additional Information to Support Approval)</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container' style={{alignItems: 'center'}}>
                        <span>supportive documents</span>
                        <div className="custom-upload-container">
                            <span className="upload-text">{fileName}</span>
                            <label className="browse-button">
                                Browse
                                <input type="file" ref={fileInputRef} onChange={handleFileChange} className="file-input" />
                            </label>
                            </div>
                    </div>
                </div>
            </div>
            <div className='details-selector-wrapper'>
                <div className='title'>
                    <span>Custom Subscribers</span>
                </div>
                <div className='details-selector-wrapper-form-container'>
                    <div className='form-container' style={{ alignItems: 'center' }}>
                        <span>Custom Subscribers (CSV)</span>
                        <div className="custom-upload-container">
                            <span className="upload-text">{fileCSVName}</span>
                            <label className={csvData.length > 0 ? 'browse-button clear-btn' : 'browse-button'}>
                                { csvData.length > 0 ? (
                                    <button onClick={(e) => handleClearCSV()}>Clear</button>
                                ) : (
                                    <>
                                        Browse
                                        <input type="file" ref={fileInputCSVRef} onChange={handleCSVFileChange} className="file-input" accept='.csv,text/csv' style={{ textTransform: 'none' }} />
                                    </>
                                )}
                                
                            </label>
                        </div>
                    </div>
                    {csvErrors && (
                        <div className='csv-form-container'>
                            <span>{csvErrors}</span>
                            <span className='clear-button' onClick={(e) => clearCSV()}>Remove CSV</span>
                        </div>
                    )}
                    <div className='form-container' style={{ alignItems: 'center' }}>
                        <span>Custom Subscribers (CSV) Name</span>
                        <div className="custom-upload-container-picker">
                            <div className='pick-icon' onClick={(e) => setIsCSVDataPikerOpen(prevState => !prevState)}>
                                <FormIconDataPicker color='var(--color-text)' width='1rem'/>
                            </div>
                            <input type="text" ref={csvSubNameRef} placeholder={`Default name (${fileCSVName.split('.')[0]})`} />
                        </div>
                    </div>
                    <div className='check-form-container'>
                        <div className='check-box'>
                            <input type="checkbox" ref={subscriberSaveRef} id="save-subs_csv" />
                            <label htmlFor="save-subs_csv">Save subscribers data</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`button-wrapper`} style={{gridArea: 'button'}}>
                <div className={`left-side`}></div>
                <div className={`right-side`}>
                    <button className={`button-normal`} style={{backgroundColor: 'var(--color-main-red)'}}>cancel</button>
                    <button className={`button-normal`} onClick={(e) => 
                        showAlertDialog(
                            "Confirm Submit",
                            "Are you sure you want to submit this early warning?",
                            () => handleSaveClick(e), undefined)
                    }>save & submit</button>
                </div>
            </div>
            {isCSVDataPikerOpen && (
                <div className="data-picker-table-wrapper-new">
                    <div className="data-picker-table-container">
                        <div className="search-wrapper">
                            <input type="text" placeholder="Search CSVs" onChange={(e) => handleChangeExistingDataSearch(e)} />
                            <div className="search-icon">
                                <SearchIcon width="1rem" color="var(--color-main-white)" />
                            </div>
                            <div className="close-icon" onClick={(e) => setIsCSVDataPikerOpen(false)} >
                                <CloseIcon width="1.5rem" color="var(--color-text)" />
                            </div>
                        </div>
                        <div className="row header">
                            {/* <span style={{ width: '33%' }}>Country</span> */}
                            <span style={{ width: '100%' }}>CSV Name</span>
                        </div>
                        
                        {isCSVDataPickerLoading ? (
                            <div className="searching-data">
                                <img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} alt="" />
                                <span>Searching CSVs...</span>
                            </div>
                        ) : (
                            <div className="data-wrapper">
                                {existingCSVFilterData.map((sub, index) => (
                                    <div
                                        key={index}
                                        className="row"
                                        onClick={(e) => handleClickFilteredCSV(sub)}
                                    >
                                        <span style={{ width: '100%', textAlign: 'left' }}>{sub}</span>
                                    </div>
                                ))}
                            </div>
                        )}

                        {!isCSVDataPickerLoading && existingCSVFilterData.length === 0 && (
                            <div className="searching-data">
                                <span>No CSVs found.</span>
                            </div>
                        )}
                        
                    </div>
                </div>
            )}
          {alertDialogState && (
            <AlertDialog
                title={alertTitle}
                description={alertDescription}
                windowState={alertDialogState}
                setWindowState={setAlertDialogState}
                function={alertYesCallback}
                okFunction={alertOkCallback}
            />
            )}
        </div>
    )
}

export default ASWWarning